import {
  BooleanField,
  DateField,
  DeleteButton,
  EditButton,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from 'react-admin'
import Permission from '../../components/Permission'
import { EmailVerificationWarning, ResendEmailButton } from '../../components/EmailVerificationAlerts'
import { MarkVerifiedButton } from '../../components/MarkVerifiedButton'
import { PERMISSIONS } from '../../constants'

const AttendantUserShowActions = () => (
  <TopToolbar>
    <Permission permission={PERMISSIONS.MANAGE_ATTENDANT_USER}>
      <EditButton />
    </Permission>
    <ResendEmailButton />
    <Permission permission={PERMISSIONS.ADMIN}>
      <MarkVerifiedButton />
    </Permission>
    <Permission permission={PERMISSIONS.MANAGE_ATTENDANT_USER}>
      <DeleteButton mutationMode="pessimistic" redirect="/attendant-employees" confirmTitle="Excluir usuário" />
    </Permission>
  </TopToolbar>
)

const AttendantUserShow = props => (
  <Show {...props} title="Usuário frentista" actions={<AttendantUserShowActions />}>
    <SimpleShowLayout>
      <EmailVerificationWarning />
      <TextField source="name" label="Nome" />
      <TextField source="login" label="Login (email)" />
      <ReferenceField source="chainId" reference="chains" label="Rede" link={false}>
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField source="profileId" reference="profiles" label="Perfil" link={false}>
        <TextField source="name" />
      </ReferenceField>
      <BooleanField source="emailVerified" label="Email verificado" />
      <DateField source="createdAt" label="Criado em" showTime locales="pt-BR" />
    </SimpleShowLayout>
  </Show>
)

export default AttendantUserShow
